// extracted by mini-css-extract-plugin
export var askAiIcon = "_od-k";
export var category = "_od-a";
export var categoryHeader = "_od-f";
export var container = "_od-0";
export var group = "_od-b";
export var groupItems = "_od-g";
export var groupSeparator = "_od-l";
export var highlight = "_od-8";
export var loading = "_od-1";
export var noResults = "_od-3";
export var placeholder = "_od-2";
export var resultContent = "_od-5";
export var resultIcon = "_od-d";
export var resultItem = "_od-h";
export var resultMeta = "_od-9";
export var resultSubtitle = "_od-7";
export var resultSuffix = "_od-j";
export var resultTitle = "_od-6";
export var resultsList = "_od-4";
export var searchGroup = "_od-e";
export var selected = "_od-i";
export var subgroup = "_od-c";